import { ApiCall } from '../../../../services/rest-client.service'
import { ViewModel } from '../../../../view-model'
import * as ENV from '../../../../environment'

/**
 * Dashboardページ内API呼び出し定義
 * @author nabla2.metamodel.generator
 */
export const apiCalls:{[key:string]:ApiCall} = {
  'Notification Upload API': new ApiCall({
    id: 'Notification Upload API',
    method: 'POST',
    url: (m:ViewModel) => `${ENV.CMNFNC_BASE_API_ENDPOINT}/notification_upload/`,
    payload:(model:ViewModel) => ({
      notificationHtml: model.cmnfnc_base.notification_template_html,
    }),
    modelUpdate: (model:ViewModel, body:any, isMerge:boolean = false) => model,
    errorUpdate: (model:ViewModel, body:any) => ViewModel.update('errorMessages', (body.errors||[]).map((e:any) => {
      switch (Array.isArray(e.field) ? e.field[0] : e.field) {
        case 'notificationHtml': return {modelPath:'cmnfnc_base.notification_template_html', message:e.defaultMessage, id:e.messageId}
        default: return {modelPath:'_common_', message:e.defaultMessage, id:e.messageId}
      }
    }).filter((e:any) => !!e), model),
    warningUpdate: (model:ViewModel, body:any) => ViewModel.update('warningMessages', {'messages':body.warnings.map((w:any) => {
      return {modelPath:'_common_', message:w.defaultMessage, id:w.messageId}
    }).filter((w:any) => !!w), 'ignoreWarning':body.ignoreWarning}, model),
  }),

  'Online Block Status': new ApiCall({
    id: 'Online Block Status',
    method: 'GET',
    url: (m:ViewModel) => `${ENV.CMNFNC_BASE_API_ENDPOINT}/onlinestatus/`,
    payload:(model:ViewModel) => ({
      onlnMngId: model.cmnfnc_base.business_unit_selected,
    }),
    modelUpdate:(model:ViewModel, body:any, isMerge:boolean = false) => ViewModel.updates({
      'cmnfnc_base.online_block_status_flg': body.onlnFlg,
    }, model, isMerge),
    errorUpdate: (model:ViewModel, body:any) => ViewModel.update('errorMessages', (body.errors||[]).map((e:any) => {
      switch (Array.isArray(e.field) ? e.field[0] : e.field) {
        case 'onlnMngId': return {modelPath:'cmnfnc_base.business_unit_selected', message:e.defaultMessage, id:e.messageId}
        default: return {modelPath:'_common_', message:e.defaultMessage, id:e.messageId}
      }
    }).filter((e:any) => !!e), model),
    warningUpdate: (model:ViewModel, body:any) => ViewModel.update('warningMessages', {'messages':body.warnings.map((w:any) => {
      return {modelPath:'_common_', message:w.defaultMessage, id:w.messageId}
    }).filter((w:any) => !!w), 'ignoreWarning':body.ignoreWarning}, model),
  }),

  'Authorization User Blng Business Unit Info': new ApiCall({
    id: 'Authorization User Blng Business Unit Info',
    method: 'GET',
    url: (m:ViewModel) => `${ENV.CMNFNC_BASE_API_ENDPOINT}/authorizationuserblngbusinessunitinfo/`,
    payload:(model:ViewModel) => ({
      userId: model.cmnfnc_base.user.id,
    }),
    modelUpdate:(model:ViewModel, body:any, isMerge:boolean = false) => ViewModel.updates({
      'cmnfnc_base.business.business_unit_pulldown_list': (body.results||[]).map((each:any) => {
          return {
            'label':each.buName,
            'value':each.buCd,
            'tmzne':each.tmzne,
          }
        }),
    }, model, isMerge),
    errorUpdate: (model:ViewModel, body:any) => ViewModel.update('errorMessages', (body.errors||[]).map((e:any) => {
      switch (Array.isArray(e.field) ? e.field[0] : e.field) {
        case 'userId': return {modelPath:'cmnfnc_base.user.id', message:e.defaultMessage, id:e.messageId}
        default: return {modelPath:'_common_', message:e.defaultMessage, id:e.messageId}
      }
    }).filter((e:any) => !!e), model),
    warningUpdate: (model:ViewModel, body:any) => ViewModel.update('warningMessages', {'messages':body.warnings.map((w:any) => {
      return {modelPath:'_common_', message:w.defaultMessage, id:w.messageId}
    }).filter((w:any) => !!w), 'ignoreWarning':body.ignoreWarning}, model),
  }),

}


// WEBPACK FOOTER //
// ./src/features/cmnfnc-base/pages/plncmm10000sc00-00/plncmm10000sc00-00.api-call.page.ts